<template>
  <div class="c-settings">
    <div class="c-settings__pages-per-view">
      <h3 class="c-settings__pages-per-view__title">{{$t('PAGES_PER_VIEW')}}</h3>

      <div class="c-settings__pages-per-view__wrapper">
        <button
        class="c-settings__pages-per-view__box"
        :class="pagesPerView === 1 ? 'active' : ''"
        @click="setPagesPerView(1);closeModal()"
        :aria-selected="pagesPerView === 1 ? 'true' : 'false'">
          <div class="c-settings__pages-per-view__checked-circle"></div>
          <one-page-view></one-page-view>
          <span class="c-settings__pages-per-view__text">
            {{ $t('ONE_PAGE') }}
          </span>
        </button>
        <button
        class="c-settings__pages-per-view__box"
        :class="pagesPerView === 2 ? 'active' : ''"
        @click="setPagesPerView(2);closeModal()"
        :aria-selected="pagesPerView === 2 ? 'true' : 'false'">
          <div class="c-settings__pages-per-view__checked-circle"></div>
          <two-pages-view></two-pages-view>
          <span class="c-settings__pages-per-view__text">{{ $t('TWO_PAGES') }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

import OnePageView from '@/assets/svg/OnePageView'
import TwoPagesView from '@/assets/svg/TwoPagesView'

export default {
  name: 'Settings',

  components: {
    'one-page-view': OnePageView,
    'two-pages-view': TwoPagesView
  },

  computed: {
    ...mapState('userSettings', {
      pagesPerView: state => state.pagesPerView
    })
  },

  methods: {
    ...mapActions({
      setPagesPerView: 'userSettings/setPagesPerView',
      closeModal: 'bookMenu/closeModal'
    })
  }
}
</script>

<style lang="scss">
@import '@/assets/scss/_vars.scss';
@import '@/assets/scss/_mixin.scss';

.c-settings__pages-per-view {
  vertical-align: middle;
}

.c-settings__pages-per-view__title {
  font-weight: 600;
  color: $blue;
}

.c-settings__pages-per-view__wrapper {
  display: flex;
  padding: 0.7rem;
}

.c-settings__pages-per-view__checked-circle:after {
  content: '';

  width: 0.7rem;
  height: 1.1rem;

  margin-bottom: 0.2rem;

  border: solid $orange;
  border-width:0 5px 5px 0;
  transform: rotate(45deg);
}

.c-settings__pages-per-view__checked-circle {
  display: none;
  position: absolute;

  top: -1rem;
  right: -1rem;
  width: 2rem;
  height: 2rem;

  background: $white;
  border-radius: 50%;
  border: 3px solid $dark-blue;
  cursor: pointer;
}

.c-settings__pages-per-view__box {
  @include btnReset();
  display: flex;
  justify-content: center;
  align-items: center;

  position: relative;

  margin: 1.875rem 0.7rem 0;
  padding: 1.25rem;

  border: 2px solid $blue;
  border-radius: 1rem;

  cursor: pointer;

  @include a11yOutline();

  .page-lines {
    fill: $very-light-pink;
  }

  .page-bg {
    fill: $blue;
  }

  &:hover {
    background: rgba($blue, 0.1);
  }

  &.active {
    background: $blue;
    color: $white;

    &:hover {
      background: rgba($blue, 0.9);
    }

    .page-lines {
      fill: $blue;
    }

    .page-bg {
      fill: $very-light-pink;
    }

    .c-settings__pages-per-view__checked-circle {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}

.c-settings__pages-per-view__text {
  margin-left: 0.75rem;
}
</style>
